module.exports = __webpack_public_path__ + "e8900e2d6b67b0135a3d99720ccb8ea5.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/projekte/mythos-3.jpg
// module id = 668
// module chunks = 0